import React from 'react';
import DemoBanner from '../components/DemoBanner';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiMapPin } = FiIcons;

const Contact = () => {
  return (
    <div className="min-h-screen py-16 lg:py-24 bg-gray-50 flex flex-col items-center">
      <div className="max-w-2xl w-full px-4 sm:px-6 lg:px-8">
        <DemoBanner />
        
        <div className="bg-white rounded-3xl border border-gray-200 p-12 shadow-sm text-center">
          <h1 className="text-3xl font-bold text-brand-dark mb-12 tracking-tight">Contact</h1>
          
          <div className="space-y-8 flex flex-col items-center">
            {/* E-mail sectie - Strikt geen link of mailto */}
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center text-brand-dark mb-1">
                <SafeIcon icon={FiMail} className="w-6 h-6" />
              </div>
              <span className="text-xl font-medium text-brand-dark select-all">
                vacature.ai@gmail.com
              </span>
            </div>

            {/* Locatie sectie */}
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center text-brand-dark mb-1">
                <SafeIcon icon={FiMapPin} className="w-6 h-6" />
              </div>
              <span className="text-lg text-gray-600">
                Amsterdam, Nederland
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;